import {BaseMobxStore} from "../../../../infrastructure/mobx/base-mobx-store";
import {CurrentOddsModuleConfig} from "./current-odds-module.config";
import {CurrentOddsModuleState} from "./models/current-odds-module.state";

export class CurrentOddsModuleStore extends BaseMobxStore {

  static injectables = [CurrentOddsModuleConfig, CurrentOddsModuleState];

  toggleCurrentOddsDropdownVisible(){
    this.state.menuOpen = !this.state.menuOpen;
  }
}